/**
 * Facility List Skeleton Component
 * Loading skeleton for facility list display
 * Provides better perceived performance during data fetching
 */

import React from 'react';

const FacilityCardSkeleton = () => {
  return (
    <div className="bg-white border-2 border-[#d3d6dc] rounded-[12px] p-4 animate-pulse">
      <div className="flex items-center gap-3">
        {/* Checkbox Skeleton */}
        <div className="w-[18px] h-[18px] bg-gray-200 rounded-[3px] shrink-0" />

        {/* Content Skeleton */}
        <div className="flex-1 space-y-2">
          {/* Facility Name */}
          <div className="h-5 w-3/4 bg-gray-200 rounded" />

          {/* Address */}
          <div className="h-4 w-full bg-gray-200 rounded" />
          <div className="h-4 w-2/3 bg-gray-200 rounded" />
        </div>

        {/* Actions Skeleton */}
        <div className="flex gap-2 shrink-0">
          <div className="w-8 h-8 bg-gray-200 rounded" />
          <div className="w-8 h-8 bg-gray-200 rounded" />
        </div>
      </div>
    </div>
  );
};

export const FacilityListSkeleton = () => {
  return (
    <div className="flex flex-col gap-3 w-full">
      {/* Header Skeleton */}
      <div className="flex items-center justify-between gap-4 mb-3">
        <div className="h-7 w-24 bg-gray-200 rounded animate-pulse" />
        <div className="h-[37px] w-[154px] bg-gray-200 rounded-[10px] animate-pulse" />
      </div>

      {/* Facility Cards Skeleton */}
      <div className="space-y-3">
        <FacilityCardSkeleton />
        <FacilityCardSkeleton />
        <FacilityCardSkeleton />
      </div>
    </div>
  );
};

export default FacilityListSkeleton;
